var map = {
	"./myhome.js": "Fbdr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Bofo";


//////////////////
// WEBPACK FOOTER
// ./src/router/myhome nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = Bofo
// module chunks = 225